import(/* webpackMode: "eager" */ "/app/frontend-next/src/app/global-error.tsx");
